@if (loadedError) {
<app-widgets-overlay [type]="loadedErrorReason"></app-widgets-overlay>
} @if (!loadedError && loaded && !data) {
<app-widgets-overlay type="no-match"></app-widgets-overlay>
} @if (loaded) {
<div class="widget-container d-flex flex-column">
    <div class="widget-container__object">
        @if (!noTitle) {
        <h1 class="widget-title align-self-center">
            {{ 'web.widget_under_over_' + type + '_last' + num + '_games' | translate }}
        </h1>
        }
        <div class="d-flex">
            @if (data?.home; as p) {
            <div class="widget-team mt-1 d-flex flex-column" data-cy="team">
                <div class="widget-team__name d-flex align-items-center">
                    <img
                        (error)="imageError($event)"
                        [attr.src]="p.image | responsive : 'participant' : 'medium'"
                        [alt]="p.name"
                        class="img-fluid app-cursor mr-1"
                    />
                    <div>{{ p.name }}</div>
                </div>
            </div>
            } @if (data?.away; as p) {
            <div class="widget-team mt-1 d-flex flex-column widget-team--second" data-cy="team">
                <div class="widget-team__name d-flex align-items-center justify-content-end">
                    <div>{{ p.name }}</div>
                    <img
                        (error)="imageError($event)"
                        [attr.src]="p.image | responsive : 'participant' : 'medium'"
                        [alt]="p.name"
                        class="img-fluid app-cursor ml-1"
                    />
                </div>
            </div>
            }
        </div>
        <div class="d-flex flex-column widget-form-participant-container">
            <div class="d-flex justify-content-between">
                <div class=" ">&nbsp;</div>
                <div class="widget-form-participant-text align-self-end">
                    {{ 'web.avg_goal_sum' | translate }}
                </div>
                <div class=" ">&nbsp;</div>
            </div>
            <div class="d-flex align-content-stretch widget-form-participant--big">
                <div class="widget-form-participant-bar widget-form-participant-bar--home" [style.width.%]="30">
                    <span class="widget-form-participant-bar--big2" data-cy="avg-home">{{
                        avgHome | number : '1.1'
                    }}</span>
                    <br />
                    {{ data?.home?.name }}
                </div>
                <div
                    class="widget-form-participant-bar widget-form-participant-bar--uni widget-form-participant-bar--big text-center"
                    data-cy="avg-total"
                >
                    {{ avgTotal | number : '1.1' }}
                </div>
                <div class="widget-form-participant-bar widget-form-participant-bar--away" [style.width.%]="30">
                    <span class="widget-form-participant-bar--big2" data-cy="avg-away">{{
                        avgAway | number : '1.1'
                    }}</span>
                    <br />
                    {{ data?.away?.name }}
                </div>
            </div>
        </div>
        <div class="d-flex widget-form-participant-container flex-column">
            <div>
                <h2 class="text-center widget-form-participant-container-h2">{{ 'web.over' | translate }}</h2>
                @for (uo of uoData; track $index) {
                <div data-cy="uo-item-over">
                    <div class="d-flex flex-column widget-form-participant-container">
                        <div class="d-flex justify-content-between">
                            <app-chart-circle-somple [percentage]="getPrct('home', uo)" [text]="data?.home?.name">
                                {{ getPrct('home', uo) }}%
                            </app-chart-circle-somple>
                            <div
                                class="text-center widget-form-participant-container-under-text --graph-text d-flex align-items-center justify-content-center"
                            >
                                + {{ uo }}
                            </div>
                            <app-chart-circle-somple [percentage]="getPrct('away', uo)" [text]="data?.away?.name">
                                {{ getPrct('away', uo) }}%
                            </app-chart-circle-somple>
                        </div>
                    </div>
                </div>
                }
            </div>
            <div>
                <h2 class="text-center widget-form-participant-container-h2">{{ 'web.under' | translate }}</h2>
                @for (uo of uoData; track $index) {
                <div data-cy="uo-item-under">
                    <div class="d-flex flex-column widget-form-participant-container">
                        <div class="d-flex justify-content-between">
                            <app-chart-circle-somple
                                [percentage]="getPrct('home', uo, 'under')"
                                [text]="data?.home?.name"
                            >
                                {{ getPrct('home', uo, 'under') }}%
                            </app-chart-circle-somple>
                            <div
                                class="text-center widget-form-participant-container-under-text --graph-text d-flex align-items-center justify-content-center"
                            >
                                - {{ uo }}
                            </div>
                            <app-chart-circle-somple
                                [percentage]="getPrct('away', uo, 'under')"
                                [text]="data?.away?.name"
                            >
                                {{ getPrct('away', uo, 'under') }}%
                            </app-chart-circle-somple>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
        @if (equal) {
        <div class="d-flex widget-form-participant-container">
            <div class="flex-fill">
                <h2 class="text-center widget-form-participant-container-h2">{{ 'web.equal' | translate }}</h2>
                @for (uo of uoData; track $index) {
                <div data-cy="uo-item-equal">
                    <div class="d-flex">
                        <div
                            class="widget-form-participant-bar widget-form-participant-bar--home"
                            [style.width.%]="width('home', uo, 'equal')"
                        >
                            {{ getPrct('home', uo, 'equal') }}%
                        </div>
                        <div
                            class="widget-form-participant-bar widget-form-participant-bar--away"
                            [style.width.%]="width('away', uo, 'equal')"
                        >
                            {{ getPrct('away', uo, 'equal') }}%
                        </div>
                    </div>
                    <div class="text-center widget-form-participant-container-under-text">= {{ uo }}</div>
                </div>
                }
            </div>
        </div>
        }
        <div class="w-100 text-center widget-form-participant-text app-word-nowrap">
            {{ 'web.num_of_matches' | translate }} ({{ num }})
        </div>
        <div class="widget-logo d-flex justify-content-center mt-4">
            <img
                [src]="'/img/' + client.getName() + '.png'"
                [alt]="client.getName()"
                data-cy="logo"
                class="widget-logo-client"
            />
        </div>
    </div>
</div>
}
